const { getAxiosInstance } = require('../connection');

module.exports = {
    all: function () {
        return getAxiosInstance({
            url:  '/virtualrooms/schedule',
            method: 'GET',
            json: true,
        }).then((response) => response.data);
    },
    addMeeting: function (roomId, name, startDate, endDate, timezone) {
        return getAxiosInstance({
            url: ['virtualrooms', encodeURIComponent(roomId), 'meetings'].join('/'),
            method: 'POST',
            json: true,
            data: {
                name: name,
                start_local: startDate,
                end_local: endDate,
                timezone: timezone,
            },
        }).then((response) => response.data);
    },
    updateMeeting: function (roomId, meetingId, name, startDate, endDate, timezone) {
        return getAxiosInstance({
            url: ['virtualrooms', encodeURIComponent(roomId), 'meetings', encodeURIComponent(meetingId)].join('/'),
            method: 'PUT',
            json: true,
            data: {
                name: name,
                start_local: startDate,
                end_local: endDate,
                timezone: timezone,
            },
        }).then((response) => response.data);
    },
    deleteMeeting: function (roomId, meetingId) {
        return getAxiosInstance({
            url: ['virtualrooms', encodeURIComponent(roomId), 'meetings', encodeURIComponent(meetingId)].join('/'),
            method: 'DELETE',
            json: true,
        }).then((response) => response.data);
    },
};
